import * as React from "react";

interface DeleteAccountIconProps {
  /**
   * Icon colour (defaults to currentColor so it inherits from text colour)
   */
  color?: string;
  /**
   * Width of the svg (default 17)
   */
  width?: number | string;
  /**
   * Height of the svg (default 19)
   */
  height?: number | string;
  className?: string;
}

/**
 * Trash / delete icon previously loaded from `delete_account.svg`.
 * Now rendered as inline SVG so the colour can be controlled via the `color` prop or CSS `color`.
 */
const DeleteAccountIcon: React.FC<DeleteAccountIconProps> = ({
  color = "currentColor",
  width = 17,
  height = 19,
  className,
  ...rest
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 17 19"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    {...rest}
  >
    <path
      d="M2.825 18.425C2.35833 18.425 1.95833 18.2542 1.625 17.9125C1.29167 17.5708 1.125 17.175 1.125 16.725V2.575H0.85C0.6 2.575 0.395833 2.49167 0.2375 2.325C0.0791666 2.15833 0 1.95833 0 1.725C0 1.475 0.0791666 1.27083 0.2375 1.1125C0.395833 0.954167 0.6 0.875 0.85 0.875H4.95C4.95 0.625 5.03333 0.416667 5.2 0.25C5.36667 0.0833333 5.56667 0 5.8 0H10.9C11.1333 0 11.3333 0.0833333 11.5 0.25C11.6667 0.416667 11.75 0.625 11.75 0.875H15.85C16.1 0.875 16.3042 0.958333 16.4625 1.125C16.6208 1.29167 16.7 1.49167 16.7 1.725C16.7 1.975 16.6208 2.17917 16.4625 2.3375C16.3042 2.49583 16.1 2.575 15.85 2.575H15.575V16.725C15.575 17.175 15.4083 17.5708 15.075 17.9125C14.7417 18.2542 14.3417 18.425 13.875 18.425H2.825ZM2.825 2.575V16.725H13.875V2.575H2.825ZM2.825 2.575V16.725V2.575ZM8.35 10.85L10.7 13.225C10.8833 13.3917 11.0958 13.475 11.3375 13.475C11.5792 13.475 11.7917 13.3917 11.975 13.225C12.1417 13.0417 12.2292 12.8292 12.2375 12.5875C12.2458 12.3458 12.1583 12.1417 11.975 11.975L9.625 9.575L11.975 7.175C12.1417 7.00833 12.2292 6.8 12.2375 6.55C12.2458 6.3 12.1583 6.09167 11.975 5.925C11.7917 5.75833 11.5792 5.675 11.3375 5.675C11.0958 5.675 10.8833 5.75833 10.7 5.925L8.35 8.3L6.025 5.925C5.85833 5.74167 5.65417 5.65417 5.4125 5.6625C5.17083 5.67083 4.95 5.75833 4.75 5.925C4.56667 6.10833 4.47917 6.31667 4.4875 6.55C4.49583 6.78333 4.58333 7 4.75 7.2L7.1 9.575L4.75 11.95C4.58333 12.1333 4.5 12.3417 4.5 12.575C4.5 12.8083 4.58333 13.025 4.75 13.225C4.95 13.3917 5.16667 13.475 5.4 13.475C5.63333 13.475 5.84167 13.3917 6.025 13.225L8.35 10.85Z"
      fill={color}
    />
  </svg>
);

export default DeleteAccountIcon;
